import type { Auth0ProviderOptions } from '@auth0/auth0-react';
import { env } from '@/env';

export const AUTH0_CALLBACK_PATH = '/auth/callback';

export const getAuth0Config = (): Auth0ProviderOptions => ({
  domain: env.AUTH0_DOMAIN,
  clientId: env.AUTH0_CLIENT_ID,
  authorizationParams: {
    redirect_uri:
      typeof window !== 'undefined'
        ? `${window.location.origin}${AUTH0_CALLBACK_PATH}`
        : '',
    audience: env.AUTH0_AUDIENCE,
  },
  cacheLocation: 'localstorage' as const,
  useRefreshTokens: true,
  // PKCE transactions are temporary and tab-specific. Refresh tokens provide
  // persistent sessions; transaction cookies are unnecessary and can collide
  // when two tabs authenticate concurrently.
  useCookiesForTransactions: false,
});
